//FETCH_CMS_DATA Actions
export const FETCH_CMS_DATA_SUCCESS = "FETCH_CMS_DATA_SUCCESS";
export const FETCH_CMS_DATA_ERROR = "FETCH_CMS_DATA_ERROR";

//UPDATE_CMS_DATA Actions
export const UPDATE_CMS_DATA_SUCCESS = "UPDATE_CMS_DATA_SUCCESS";
export const UPDATE_CMS_DATA_ERROR = "UPDATE_CMS_DATA_ERROR";